import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Load,
  openSnack,
  snackMessage,
  toggleOpenDeleteDialog,
  toggleAttendantsDetailsDialog,
  toggleCollapseAttendantsForm,
} from "../redux/GlobalStates";
import { itemsSuccess } from "../redux/items";
import { LoginSuccess } from "../redux/login";
import { receiptsSuccess } from "../redux/receipts";
import { salesSuccess } from "../redux/sales";
import { request } from "../request";
import moment from "moment";
import { Check, Close, Delete, Edit, Visibility } from "@mui/icons-material";
import { expensesSuccess } from "../redux/expenses";
import { creditsSuccess } from "../redux/Credit";
import { invoiceSuccess } from "../redux/invoice";
const useAccount = () => {
  const storeInfo = useSelector((state) => state.store.Store);

  const dispatch = useDispatch();
  const toggleCollapseForm = () => dispatch(toggleCollapseAttendantsForm());
  const [loginDetails, setLoginDetails] = useState({
    id: localStorage.getItem("storeId") || "",
    password: "",
    admin: false,
    username: "",
  });
  const [newAttendant, setNewAttendant] = useState({
    name: "",
    password: "",
    sell_item: true,
    add_item: false,
    edit_item: false,
    restock_item: false,
    delete_item: false,
    view_store_summary: false,
    see_sales_details: false,
    offer_discount: false,
    id: Math.round(Math.random() * 99999).toString(),
    added_at: moment().format("DD/MM/YYYY"),
    manage_expenses: false,
    manage_credit: false,
  });
  const [editAttendant, setEditAttendant] = useState(false);
  const toggleDeleteDialog = () => dispatch(toggleOpenDeleteDialog());
  const attendants = storeInfo?.attendants;
  const handleLogin = async (loginDetails) => {
    dispatch(Load());
    if (!loginDetails.id || loginDetails.password.length < 5) {
      dispatch(snackMessage("Invalid login inputs"));
      return;
    } else {
      try {
        const res = await request.post("/auth", loginDetails);
        dispatch(LoginSuccess(res.data.store));
        localStorage.setItem("storeId", loginDetails.id);
        dispatch(itemsSuccess(res.data.items));
        dispatch(salesSuccess(res.data.sales));
        dispatch(receiptsSuccess(res.data.receipts));
        dispatch(expensesSuccess(res.data.expenses));
        dispatch(creditsSuccess(res.data.credit));
        dispatch(invoiceSuccess(res.data.invoice));
        dispatch(
          snackMessage("Login successful. Your store data is fully loaded.")
        );
      } catch (err) {
        dispatch(snackMessage(err.response ? err.response.data : err.message));
      }
    }
    dispatch(Load());
    dispatch(openSnack());
  };
  // new store
  const [newStore, setNewStore] = useState({
    name: "",
    location: "",
    phone: "",
    email: "",
    password: "",
    password2: "",
    createdAt: moment().format("DD/MM/YYYY"),
    id: (Math.floor(Math.random() * 100000) + 100000).toString().substring(1),
    trialEndsAt: moment().add(30, "days").format("DD/MM/YYYY"),
    referred: false,
    referrer: "",
  });
  const [attendant, setAttendant] = useState();

  const handleRegister = async (newStore) => {
    dispatch(Load());
    if (
      !newStore.name ||
      newStore.password.length < 5 ||
      (newStore.referred && !newStore.referrer)
    ) {
      dispatch(snackMessage("Provide value for all fields!"));
    } else if (newStore.password !== newStore.password2) {
      dispatch(snackMessage("Passwords do not match"));
    } else {
      try {
        const res = await request.post("/store", {
          ...newStore,
          referrer: newStore.referred ? newStore.referrer : "",
        });
        await localStorage.setItem("storeId", newStore.id);
        window.location.href = "/login";
        dispatch(snackMessage(res.data));
      } catch (err) {
        dispatch(snackMessage(err.response?.data || err.message));
      }
    }
    dispatch(openSnack());
    dispatch(Load());
  };
  // const new attendant
  const addNewAttendant = async () => {
    dispatch(Load());
    if (newAttendant.name.length < 2 || newAttendant.password.length < 5) {
      dispatch(snackMessage("Invalid inputs!"));
    } else {
      try {
        const res = await request.put(
          `/store?id=${loginDetails?.id}`,
          newAttendant
        );
        dispatch(
          LoginSuccess({
            ...storeInfo,
            attendants: [...storeInfo?.attendants, newAttendant],
          })
        );
        setNewAttendant({});
        dispatch(snackMessage(res.data));
      } catch (err) {
        dispatch(snackMessage(err.response?.data || "network error"));
      }
    }
    dispatch(openSnack());
    dispatch(Load());
  };
  // edit attendant
  const handleEditAttendant = async () => {
    dispatch(Load());
    const newAttendantsList = attendants?.map((elem) =>
      elem.id === newAttendant?.id ? newAttendant : elem
    );
    if (newAttendant.name.length < 2 || newAttendant.password.length < 5) {
      dispatch(snackMessage("Invalid inputs!"));
    } else {
      try {
        const res = await request.put(
          `/store/attendant?id=${loginDetails?.id}`,
          newAttendant
        );
        dispatch(
          LoginSuccess({
            ...storeInfo,
            attendants: newAttendantsList,
          })
        );
        dispatch(snackMessage(res.data));
      } catch (err) {
        dispatch(snackMessage(err.response?.data || "network error"));
      }
    }
    dispatch(openSnack());
    dispatch(Load());
  };
  // delete attendant
  const deleteAttendant = async (id) => {
    dispatch(Load());
    const updatedAttendantsList = attendants?.filter((elem) => elem.id !== id);
    try {
      const res = await request.delete(
        `/store/attendant?id=${storeInfo.id}&attendant_id=${id}`
      );
      dispatch(
        LoginSuccess({ ...storeInfo, attendants: updatedAttendantsList })
      );
      dispatch(snackMessage(res.data));
      dispatch(toggleOpenDeleteDialog());
    } catch (err) {
      dispatch(snackMessage(err.response?.data || "network error"));
    }
    dispatch(openSnack());
    dispatch(Load());
  };

  const attendantsColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => (
        <div className="attendants-action-container">
          <Visibility
            className="attendant-action-icon"
            onClick={() => {
              setAttendant(params.row);
              dispatch(toggleAttendantsDetailsDialog());
            }}
          />
          <Edit
            className="attendant-action-icon"
            onClick={() => {
              setNewAttendant({
                ...params.row,
                password: "",
              });
              setEditAttendant(true);
            }}
          />
          <Delete
            className="attendant-action-icon"
            onClick={() => {
              setAttendant(params.row);
              toggleDeleteDialog();
            }}
          />
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Attendant",
      width: 200,
    },
    {
      field: "sell_item",
      headerName: "Sell",
      width: 70,
      renderCell: (params) =>
        params.row.sell_item === true ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
    {
      field: "add_item",
      headerName: "Add",
      width: 70,
      renderCell: (params) =>
        params.row.add_item ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
    {
      field: "edit_item",
      headerName: "Edit",
      width: 70,
      renderCell: (params) =>
        params.row.edit_item ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
    {
      field: "restock_item",
      headerName: "Restock",
      width: 70,
      renderCell: (params) =>
        params.row.restock_item ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
    {
      field: "delete_item",
      headerName: "Delete",
      width: 70,
      renderCell: (params) =>
        params.row.delete_item ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
    {
      field: "see_sales_details",
      headerName: "See sales",
      width: 70,
      renderCell: (params) =>
        params.row.see_sales_details ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
    {
      field: "view_store_summary",
      headerName: "Summary",
      width: 70,
      renderCell: (params) =>
        params.row.view_store_summary ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
    {
      field: "offer_discount",
      headerName: "Discount",
      width: 70,
      renderCell: (params) =>
        params.row.offer_discount ? (
          <Check className="checked" />
        ) : (
          <Close className="unchecked" />
        ),
    },
  ];
  return {
    handleLogin,
    loginDetails,
    setLoginDetails,
    newStore,
    setNewStore,
    handleRegister,
    newAttendant,
    setNewAttendant,
    addNewAttendant,
    attendantsColumn,
    attendants,
    editAttendant,
    handleEditAttendant,
    deleteAttendant,
    attendant,
    toggleDeleteDialog,
    toggleCollapseForm,
  };
};

export default useAccount;
